import { Suspense } from "react";
import { Outlet, useLocation } from "react-router";
import { MarketingNavbar } from "../components/MarketingNavbar";
import { FairPathFooter } from "../components/FairPathFooter";
import { CompactTrustFooter } from "../components/CompactTrustFooter";
import { PageLoader } from "../components/PageLoader";
import { ChunkErrorBoundary } from "../../components/ChunkErrorBoundary";
import { useAppNavigate } from "../hooks/useAppNavigate";

const PATH_TO_ACTIVE_PAGE: Record<string, string> = {
  "/": "home",
  "/pricing": "pricing",
  "/coverage": "coverage",
  "/property-taxes-by-state": "tax-comparison",
  "/faq": "faq",
  "/about": "about",
  "/contact": "contact",
};

const COMPACT_FOOTER_PATHS = [
  "/wizard",
  "/wizard/manual-entry",
  "/checkout",
  "/guest/packet",
  "/hearing",
  "/shield/dashboard",
];

function shouldUseCompactFooter(pathname: string): boolean {
  return COMPACT_FOOTER_PATHS.some((path) =>
    pathname === path || pathname.startsWith(`${path}/`)
  );
}

function shouldUseFocusedHeader(pathname: string): boolean {
  return pathname === "/wizard" || pathname.startsWith("/wizard/");
}

export function MarketingLayout() {
  const { appNavigate } = useAppNavigate();
  const location = useLocation();
  const activePage = PATH_TO_ACTIVE_PAGE[location.pathname] || "home";
  const useCompactFooter = shouldUseCompactFooter(location.pathname);
  const useFocusedHeader = shouldUseFocusedHeader(location.pathname);

  return (
    <>
      {!useFocusedHeader && (
        <MarketingNavbar activePage={activePage} onNavigate={appNavigate} showAddressCta={location.pathname !== "/property-taxes-by-state"} />
      )}
      <ChunkErrorBoundary>
        <Suspense fallback={<PageLoader />}>
          <Outlet />
        </Suspense>
      </ChunkErrorBoundary>
      {useCompactFooter ? <CompactTrustFooter /> : <FairPathFooter />}
    </>
  );
}
